import AuthService from '../services/authService';
import { getModuleByClient } from '../requests/api/module';

export const LOGIN_REQUEST = '@account/login-request';
export const LOGIN_SUCCESS = '@account/login-success';
export const LOGIN_FAILURE = '@account/login-failure';
export const SILENT_LOGIN = '@account/silent-login';
export const LOGOUT = '@account/logout';
export const UPDATE_PROFILE = '@account/update-profile';

const login = (email, password, source) => async (dispatch) => {
  try {
    dispatch({ type: LOGIN_REQUEST });
    const response = await AuthService.loginWithEmailAndPassword(email, password, source);
    if (response.success) {
      const { user } = response;
      let userWithModule = null;
      const moduleResponse = await getModuleByClient(user.clientId);
      const userData = {
        id: user.id,
        email: user.email,
        name: user.name,
        lastname: user.lastname,
        role: user.role,
        clientId: user.clientId,
        client: user.client,
      };
      if (moduleResponse.success) {
        userWithModule = {
          ...userData,
          module: moduleResponse.searchedModule,
        };
      }
      dispatch({
        type: LOGIN_SUCCESS,
        payload: {
          userData: userWithModule || userData,
        },
      });
      return;
    }
    dispatch({ type: LOGIN_FAILURE });
    throw new Error(response.errorMessage);
  } catch (err) {
    dispatch({ type: LOGIN_FAILURE });
    throw err.message;
  }
};

export function setUserData(userData) {
  return (dispatch) => dispatch({
    type: SILENT_LOGIN,
    payload: {
      userData,
    },
  });
}

export function logout() {
  return async (dispatch) => {
    AuthService.logoutSession();

    dispatch({
      type: LOGOUT,
    });
  };
}

export function register() {
  return true;
}

export default {
  login,
};
